// Central registry of test IDs for Prime Vision landing
export const PV = {
  // Header
  headerLogo: 'pv-header-logo',
  headerNavSolution: 'pv-header-nav-solution',
  headerNavWhy: 'pv-header-nav-why',
  headerNavTarget: 'pv-header-nav-target',
  headerNavContact: 'pv-header-nav-contact',
  headerLoginBtn: 'pv-header-login-btn',
  headerDemoBtn: 'pv-header-demo-btn',
  headerLangIt: 'pv-header-lang-it',
  headerLangEn: 'pv-header-lang-en',
  headerMobileToggle: 'pv-header-mobile-toggle',

  // Hero
  heroTitle: 'pv-hero-title',
  heroSubtitle: 'pv-hero-subtitle',
  heroDemoBtn: 'pv-hero-demo-btn',
  heroSurveyBtn: 'pv-hero-survey-btn',
  heroContactBtn: 'pv-hero-contact-btn',
  heroMockup: 'pv-hero-mockup',

  // Problem
  problemSection: 'pv-problem-section',

  // Validation
  validationSection: 'pv-validation-section',
  validationStat: 'pv-validation-stat',

  // Solution / bento
  solutionSection: 'pv-solution-section',
  solutionBlock: 'pv-solution-block',

  // Comparison
  comparisonSection: 'pv-comparison-section',

  // Target audience
  targetSection: 'pv-target-section',
  targetCard: 'pv-target-card',

  // CTA blocks
  ctaSection: 'pv-cta-section',
  ctaDemoBtn: 'pv-cta-demo-btn',
  ctaSurveyBtn: 'pv-cta-survey-btn',

  // Contact form
  contactSection: 'pv-contact-section',
  contactFirstName: 'pv-contact-first-name',
  contactLastName: 'pv-contact-last-name',
  contactEmail: 'pv-contact-email',
  contactPhone: 'pv-contact-phone',
  contactBirthDate: 'pv-contact-birth-date',
  contactMessage: 'pv-contact-message',
  contactPrivacy: 'pv-contact-privacy',
  contactSubmit: 'pv-contact-submit',
  contactSuccess: 'pv-contact-success',
  contactError: 'pv-contact-error',

  // Footer
  footer: 'pv-footer',
  footerLoginLink: 'pv-footer-login-link',
  footerDemoLink: 'pv-footer-demo-link',
  footerContactLink: 'pv-footer-contact-link',
  footerPrivacyLink: 'pv-footer-privacy-link',
};
